<lib-header />

<main class="flex-1 bg-[#090b0d]">
  <router-outlet />
</main>

<lib-footer />
